<script setup>
  import MapDrawingShapeCircle from '@/components/MapDrawingShapeCircle.vue';
  import MapDrawingShapePolygon from '@/components/MapDrawingShapePolygon.vue';
  import MapDrawingShapePolyline from '@/components/MapDrawingShapePolyline.vue';

  const props = defineProps({
    shape: {
      type: Object,
      required: true
    },
    drawingManager: {
      type: Object,
      required: true
    }
  });

</script>

<template>
  <MapDrawingShapePolyline
    v-if="props.shape.type === 'polyline'"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :shapeClosed="shape.closed"
    v-bind="{...props.shape.settings}"
  />
  <MapDrawingShapeCircle
    v-else-if="props.shape.type === 'circle'"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :radiusDistance="props.shape.settings.radius"
    v-bind="{...props.shape.settings}"
  />
  <MapDrawingShapePolygon
    v-else-if="props.shape.type === 'polygon'"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :shapeClosed="props.shape.closed"
    v-bind="{...props.shape.settings}"
  />
</template>